import React from "react";

function HomePageParagraph({ translate, survey, surveyIsActive, onRevisionPhase, isSurveyFinished }) {
  let paragraph = null;

  if (isSurveyFinished) {
    paragraph = <p className="sia-text-04">{translate("benchmarking.landing-page.logged-in.paragraph.finished-survey")}</p>;
    return paragraph;
  }

  if (surveyIsActive) {
    paragraph = <p className="sia-text-04">{translate("benchmarking.landing-page.logged-in.paragraph", { surveyYear: survey.surveyYear })}</p>;
    return paragraph;
  }

  if (onRevisionPhase) {
    paragraph = <p className="sia-text-04">{translate("benchmarking.landing-page.logged-in.paragraph.closed-survey")}</p>;
    return paragraph;
  }

  return paragraph;
}

export default HomePageParagraph;
